import alt from 'components/Dispatcher';
import CallSource from 'sources/files/CallSource';
import {FileUploadSource} from 'sources/files/FileUploadSource';

class CallActions {
  constructor() {
    this.generateActions(
      'changePage',
      'clearFieldsSearch',
      'clearPrevSearchTypes',
      // TODO move to SearchActions
      'clearSearch',
      'directTextSearch',
      'executeInactiveSearch',
      'fieldsSearch',
      'libraryTagsSearch',
      'myCallsSearch',
      'removeSearchType',
      'resetSearchType',
      'searchError',
      'searchLoading',
      'searchSuccess',
      'selfSearch',
      'setIsAdvancedSearch',
      'setIsSearchingSelf',
      'termFieldsSearch',
      'textSearch',
      'updateFileId',
      'updateSearchType',
      'updateIsInitialLoad',
      'addQueueSearch',
      'toggleSortByDate',
      'getPartiallyHydratedCallsSuccess',
      'getPartiallyHydratedCallsError',
      'fetchCallTeamNameSuccess',
      'setDrilldown',
      'clearDrilldown'
    );
  }
  // unlike FileUploadActions.findFilesById this will actually allow
  // retrieving multiple calls.. unforunately they are not fully hydrated
  // with the call information
  getPartiallyHydratedCalls(callIds) {
    const filtered = callIds.filter(call => !!call).toSet();
    if (filtered.size === 0) {
      return;
    }
    return dispatch => {
      dispatch(callIds);
      return FileUploadSource.findFilesById(callIds).then(
        this.getPartiallyHydratedCallsSuccess,
        () => this.getPartiallyHydratedCallsError(callIds)
      );
    };
  }

  fetchCallTeamName(fileUploadId) {
    return dispatch => {
      dispatch(fileUploadId);
      return CallSource.fetchCallTeamName(fileUploadId).then(result =>
        this.fetchCallTeamNameSuccess([fileUploadId, result])
      );
    };
  }
}

export default alt.createActions(CallActions);
